import {inject, Injectable} from '@angular/core';
import {TutorialStore} from '../stores/tutorial.store';
import {QueryService} from '../modules/akita-mimic/services/query.service';
import {TutorialState} from '../modules/akita-mimic/models/store-states/tutorial-state.model';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TutorialQuery extends QueryService<TutorialState> {
    public isTutorialHidden$: Observable<boolean> = this.select('isHidden');

    public constructor() {
        const store = inject(TutorialStore);
        super(store);
    }

    public getReadTutorialStepIds(): Array<string> {
        return this.getValue().readTutorialStepIds;
    }

    public getIsTutorialHidden(): boolean {
        return this.getValue().isHidden;
    }
}
